import { BaseCrossAnalysisUseCase } from './base-cross-analysis-use-case'
import { IQueryRepository } from '../repositories/i-query-repository'

export class TerritorialConnectivityUseCase extends BaseCrossAnalysisUseCase {
  readonly id = 'territorial-connectivity'
  readonly name = 'Conectividad Territorial para el Desarrollo'

  constructor(queryRepo: IQueryRepository) {
    super(queryRepo)
  }
}
